import moment from 'moment'
import React, { Component } from 'react'
import PropTypes, { string } from 'prop-types'
import Modal from 'react-bootstrap/lib/Modal'
import Button from 'react-bootstrap/lib/Button'
import Image from 'react-bootstrap/lib/Image'
import Grid from 'react-bootstrap/lib/Grid'
import Row from 'react-bootstrap/lib/Row'
import Col from 'react-bootstrap/lib/Col'
import FormGroup from 'react-bootstrap/lib/FormGroup'
import FormControl from 'react-bootstrap/lib/FormControl'
import Switch from 'react-switch'
import BookingInvitation from '../components/BookingInvitation'
import _ from 'lodash'
import { chunks } from '../utils/array.js'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  showBookingInvitationModal,
  handleDetailsDateChange,
  updateDateFocus,
  bookTimeslot,
  unbookTimeslot,
  selectTimeslot,
  hideLocationDetails,
  linkBookings,
  unlinkBookings,
  fetchCompanies,
  fetchUsersForCompany,
  fetchSearchInvitee,
  setInviteeEmail,
  addInvitee,
  removeInvitee,
  closeBookingInvitationModal,
  showSearch,
  showInvitationsList,
  setUserInSearch,
  setCompanyInSearch,
  showSwitch,
  hideSwitch,
  SwitchCompanyChange,
  SwitchBuildingChange,
  onTypeSearch
} from '../actions/locations.js'
import './LocationDetails.css'
import 'react-dates/lib/css/_datepicker.css'
import { SingleDatePicker } from 'react-dates'

class LocationDetails extends Component {
  static defaultProps = {
    selectedTimeslot: undefined,
    showSwitch: false,
    handleSwitchCompanyChange: false,
    handleSwitchBuildingChange: false,
    checked: true,
    selectedUser: String,
    showCondition: false
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    /* prevent for location details popup to appear when booking is selected */
    dispatch(fetchCompanies())
    if (this.props.account.activeBuilding) {
      dispatch(fetchUsersForCompany(this.props.account.activeBuilding._id, this.props.account._id))
    }
  }

  closeModal() {
    const { dispatch } = this.props
    dispatch(hideLocationDetails())
  }

  bookTimeslot(timeslot) {
    const { dispatch } = this.props
    dispatch(bookTimeslot(timeslot, this.props.selectedLocation, this.props.account))
  }

  closeInvitations() {
    const { dispatch } = this.props
    dispatch(closeBookingInvitationModal())
  }

  unbookTimeslot(timeslot, userId) {
    const { dispatch } = this.props
    dispatch(unbookTimeslot(timeslot, this.props.selectedLocation, this.props.account, userId))
  }

  linkBookings(booking1, booking2) {
    const { dispatch } = this.props
    dispatch(linkBookings(booking1, booking2))
  }

  unlinkBookings(booking, timeslot) {
    const { dispatch } = this.props
    dispatch(unlinkBookings(booking, timeslot.startDate, timeslot.endDate))
  }

  selectTimeslot(timeslot) {
    const { dispatch } = this.props
    dispatch(selectTimeslot(timeslot))
    dispatch(showSearch())
  }

  handleDateChange(date) {
    const { dispatch } = this.props
    let filterDate = moment(date).startOf('day')
    if (filterDate.isValid()) {
      dispatch(handleDetailsDateChange(filterDate))
    }
  }

  updateDateFocus(focused) {
    const { dispatch } = this.props
    dispatch(updateDateFocus(false, focused.focused))
  }

  showInvitations() {
    const { dispatch } = this.props
    dispatch(showBookingInvitationModal())
  }
  onSearchChanged(email) {
    const { dispatch } = this.props

    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (re.test(email)) {
      dispatch(setInviteeEmail(this.props.selectedUser.email))
    } else {
      dispatch(setInviteeEmail(undefined))
    }

    let buildingId = ''
    let companyId = ''

    let location = this.props.selectedLocation

    if (location && location.building) {
      buildingId = location.building._id
    }

    if (location && location.company) {
      companyId = location.company._id
    }

    dispatch(fetchSearchInvitee(this.props.selectedUser.email, buildingId, companyId))
  }

  onChange(options) {
    const { dispatch } = this.props

    if (options && options.length > 0) {
      if (options[0].email) {
        dispatch(setInviteeEmail(options[0].email))
      }
    }
  }

  addInvitee() {
    let location = this.props.selectedLocation
    var selectedTimeslot = this.props.selectedTimeslot
    let selectedBooking

    if (location && selectedTimeslot && location.bookings) {
      selectedBooking = location.bookings.find(booking => {
        if (
          moment(booking.startDate).isSameOrBefore(moment(selectedTimeslot.startDate)) &&
          moment(booking.endDate).isSameOrAfter(selectedTimeslot.endDate)
        ) {
          return true
        }
        return false
      })
    }
    let emailOrInvitation = this.props.selectedUser.email || this.props.selectedUser.invitation
    if (emailOrInvitation && selectedBooking) {
      const { dispatch } = this.props
      dispatch(addInvitee(emailOrInvitation, selectedBooking._id))
    }
  }

  removeInvitee(invitee) {
    let location = this.props.selectedLocation
    var selectedTimeslot = this.props.selectedTimeslot
    let selectedBooking

    if (location && selectedTimeslot && location.bookings) {
      selectedBooking = location.bookings.find(booking => {
        if (
          moment(booking.startDate).isSameOrBefore(moment(selectedTimeslot.startDate)) &&
          moment(booking.endDate).isSameOrAfter(selectedTimeslot.endDate)
        ) {
          return true
        }
        return false
      })
    }

    if (invitee.user && selectedBooking) {
      const { dispatch } = this.props
      dispatch(removeInvitee(invitee.user, selectedBooking))
    }
  }

  showSearch() {
    const { dispatch } = this.props
    dispatch(showSearch())
  }

  showInvitationsList() {
    const { dispatch } = this.props
    dispatch(showInvitationsList())
  }

  onUserSelect(evt) {
    const { dispatch } = this.props
    dispatch(setUserInSearch(evt))
  }

  onCompanySelect(company) {
    const { dispatch, companies } = this.props
    const storeCompanies = [...companies]
    const selectedCompany = {
      ...company
    }
    selectedCompany.selected ? (selectedCompany.selected = false) : (selectedCompany.selected = true)
    const companyForEditIndex = companies.findIndex(el => el._id === company._id)
    if (companyForEditIndex > -1) {
      storeCompanies[companyForEditIndex] = selectedCompany
    }
    dispatch(setCompanyInSearch(storeCompanies))
  }
  showSwitch(evt) {
    const { dispatch } = this.props
    dispatch(showSwitch())
  }

  hideSwitch(evt) {
    const { dispatch } = this.props

    dispatch(hideSwitch())
  }

  handleSwitchCompanyChange(evt) {
    const { dispatch } = this.props
    dispatch(SwitchCompanyChange())
  }

  handleSwitchBuildingChange(checked) {
    const { dispatch } = this.props
    dispatch(SwitchBuildingChange(checked))
  }

  intersection = (myCompanies, userCompanies) => {
    for (let i = 0; i < myCompanies.length; i++) {
      var myCurrentCompany = myCompanies[i]
      for (let j = 0; j < userCompanies.length; j++) {
        if (myCurrentCompany._id == userCompanies[j]._id) {
          return true
        }
      }
    }
    return false
  }

  getUsersWithTheSameCompany = (users, companies) => {
    var usersWithSameCompany = []
    if (users && companies) {
      for (let i = 0; i < users.length; i++) {
        var currentUser = users[i]
        if (this.intersection(companies, currentUser.companies)) {
          usersWithSameCompany.push(currentUser)
        }
      }
    }
    return usersWithSameCompany
  }

  onTypeSearch(event) {
    const { dispatch } = this.props
    dispatch(onTypeSearch(event))
  }

  handleChange(e) {
    const { dispatch } = this.props
    dispatch(onTypeSearch(e.target.value))
  }

  render() {
    let inviteeEmail = this.props.inviteeEmail
    let account = this.props.account
    let companyName = ''
    let location = this.props.selectedLocation
    var selectedTimeslot = this.props.selectedTimeslot
    let selectedBooking
    let found

    const { showSwitch, loading, options, companies, users, checkedByBuilding } = this.props

    let filteredUsers = []
    if (checkedByBuilding) {
      filteredUsers = users // get users from the same building
    } else {
      if (showSwitch) {
        filteredUsers = this.getUsersWithTheSameCompany(users, account.companies)
      } else {
        const selectedCompanies = this.props.companies && this.props.companies.filter(comp => comp.selected)
        // get users for selected companies;
        filteredUsers = this.getUsersWithTheSameCompany(users, selectedCompanies)
      }
    }
    if (this.props.typedText) {
      filteredUsers = filteredUsers.filter(el =>
        (el.fullName || el.invitation).toLowerCase().includes(this.props.typedText.toLowerCase())
      )
    }

    let filterDate = moment(this.props.filterDate)

    if (!this.props.selectedLocation) {
      return <div />
    }

    if (this.props.detailsFilterDate) {
      filterDate = moment(this.props.detailsFilterDate)
    }

    if (selectedTimeslot) {
      selectedBooking = location.bookings.find(booking => {
        if (
          moment(booking.startDate).isSameOrBefore(moment(selectedTimeslot.startDate)) &&
          moment(booking.endDate).isSameOrAfter(selectedTimeslot.endDate)
        ) {
          return true
        }
        return false
      })
    }

    /* fucntionalitatea pentru afisarea companiilor
			se efectueaza o filtrare pe toate companiile si se verifica id-ul dompaniei cu id-ul userului */

    if (selectedBooking) {
      if (this.props.companiesFetched) {
        if (this.props.companies.length > 0) {
          let filteredCompanies = this.props.companies.filter(company => {
            let foundCompanies = selectedBooking.user.companies.filter(userCompany => {
              return userCompany._id == company._id
            })
            return foundCompanies.length > 0
          })
          if (filteredCompanies.length > 0) {
            companyName = filteredCompanies[0].name
          }
        }
      }
      /* se creeaza array de account_.id si de user._id */
      let companyAccountId = this.props.account.companies.map(companyId => {
        return companyId._id
      })
      let companyUserId = selectedBooking.user.companies.map(companyId => {
        return companyId._id
      })
      /* found returneaza true daca cel putin un element din primul array se regaseste in cel de-al doilea array */
      found = companyAccountId.some(r => companyUserId.includes(r))
    }

    let timeslots = []

    if (location.availableDates) {
      var availableDate = location.availableDates.find(x => {
        return moment(x.startDate).isSameOrBefore(filterDate) && moment(x.endDate).isSameOrAfter(filterDate)
      })

      if (availableDate && location.availableTimes) {
        timeslots = location.availableTimes.filter(timeslot => {
          return timeslot.weekday == filterDate.day()
        })
      }
    }

    var availableIntervals = []

    if (timeslots.length > 0) {
      for (var timeslot of timeslots) {
        let startTime = moment(timeslot.startDate)
        let endTime = moment(timeslot.endDate)
        let duration = moment.duration(endTime.diff(startTime)).asMinutes()

        if (duration > 30) {
          let startDate = startTime
          startDate.year(filterDate.year())
          startDate.month(filterDate.month())
          startDate.date(filterDate.date())
          let endDate = endTime
          endDate.year(filterDate.year())
          endDate.month(filterDate.month())
          endDate.date(filterDate.date())

          do {
            duration = moment.duration(endDate.diff(startDate)).asMinutes()
            duration = duration > 30 ? 30 : duration

            let intervalStartDate = moment(startDate)
            let intervalEndDate = moment(startDate).add({ minutes: duration })

            let intervalInfo = {
              startDate: intervalStartDate,
              endDate: intervalEndDate,
              duration: duration
            }

            if (location.bookings) {
              let booking = location.bookings.find(booking => {
                if (
                  moment(booking.startDate).isSameOrBefore(intervalStartDate) &&
                  moment(booking.endDate).isSameOrAfter(intervalEndDate)
                ) {
                  return true
                }
                return false
              })

              if (booking) {
                intervalInfo.booking = booking
              }
            }

            availableIntervals.push(intervalInfo)

            startDate.add({ minutes: duration })
          } while (startDate.isBefore(endDate))
        }
      }
    }
    var organizedIntervals = chunks(availableIntervals, 4)

    return (
      <div style={{ height: 120, width: 200 }}>
        <Modal
          className='locationDetails'
          show={this.props.selectedLocation && !this.props.showBookingInvitationModal}
          onHide={this.closeModal.bind(this)}>
          <Modal.Header closeButton={true} />
          <Modal.Body style={{ padding: '0px' }}>
            <div className='locationScrollableContent scrollableContainer'>
              {selectedBooking ? (
                <div>
                  {(found && this.props.account.role === 'company_manager') ||
                  (selectedBooking && this.props.account._id === selectedBooking.user._id) ? (
                    <div
                      onClick={this.showSearch.bind(this)}
                      className='inviteButton'
                      style={{
                        float: 'left',
                        height: '2em',
                        margin: '5px',
                        paddingTop: '15px',
                        paddingLeft: '15px'
                      }}>
                      <img
                        style={{
                          width: '2em',
                          height: '2em',
                          margin: '5px'
                        }}
                        src='/images/left.png'
                      />
                    </div>
                  ) : (
                    <div />
                  )}

                  <div>
                    {this.props.showCondition ? (
                      <div>
                        <div
                          style={{
                            float: 'left',
                            height: '2em',
                            margin: '5px',
                            fontSize: '17px',
                            // paddingRight: '250px',
                            paddingTop: '25px'
                          }}>
                          {this.props.checkedByBuilding ? <div>My Building Users</div> : <div>My Company Users</div>}
                        </div>
                        <div>
                          <div>
                            {this.props.showSwitch === false ? (
                              <div
                                onClick={this.showSwitch.bind(this)}
                                className='inviteButton'
                                style={{
                                  float: 'right',
                                  height: '2em',
                                  margin: '5px',
                                  paddingTop: '15px',
                                  paddingRight: '10px',
                                  // paddingLeft: '500px',
                                  display: 'inline'
                                }}>
                                <img
                                  style={{
                                    transform: 'rotate(90deg) scaleX(-1)',
                                    width: '2em',
                                    height: '2em',
                                    margin: '5px'
                                  }}
                                  src='/images/next_icon.png'
                                />
                              </div>
                            ) : (
                              <div
                                onClick={this.hideSwitch.bind(this)}
                                style={{
                                  float: 'right',
                                  height: '2em',
                                  margin: '5px',
                                  paddingTop: '10px'
                                }}>
                                <img
                                  style={{
                                    transform: 'rotate(90deg) scaleX(1)',
                                    width: '2em',
                                    height: '2em',
                                    margin: '5px'
                                  }}
                                  src='/images/next_icon.png'
                                />
                              </div>
                            )}

                            <div style={{ width: '100%', float: 'left' }}>
                              <br />

                              {this.props.showSwitch === true ? (
                                <div>
                                  <br />
                                  <div>
                                    <label>
                                      <span
                                        style={{ paddingBottom: '50px', paddingLeft: '15px', paddingRight: '296px' }}>
                                        Show all users in my building
                                      </span>
                                      <Switch
                                        className='react-switch'
                                        onChange={this.handleSwitchBuildingChange.bind(this)}
                                        checked={this.props.checkedByBuilding}
                                      />{' '}
                                    </label>
                                  </div>
                                  <hr style={{ marginTop: '0.2px', marginBottom: '0.2px' }} />
                                  <div>
                                    <label>
                                      <span
                                        style={{ paddingBottom: '50px', paddingLeft: '15px', paddingRight: '289.5px' }}>
                                        Show all users in my company
                                      </span>
                                      <Switch
                                        className='react-switch'
                                        onChange={this.handleSwitchCompanyChange.bind(this)}
                                        checked={this.props.checked}
                                      />{' '}
                                    </label>
                                  </div>
                                </div>
                              ) : (
                                <div />
                              )}
                              {this.props.showSwitch === true ? (
                                <div>
                                  <br />
                                  <br />

                                  {companies && companies.length ? (
                                    companies.map(company => {
                                      return (
                                        <ul style={{ listStyleType: 'none', paddingLeft: '15px' }}>
                                          <li>
                                            <label className='container'>
                                              <input
                                                type='checkbox'
                                                checked={company.selected}
                                                onChange={this.onCompanySelect.bind(this, company)}
                                              />
                                              <h5 style={{ float: 'left' }}>{company.name}</h5>
                                              <span className='checkmark' style={{ float: 'right' }} />
                                            </label>
                                            {/* <hr style={{ marginTop: '0.2px', marginBottom: '0.2px' }} /> */}
                                            <div className='horizontal-rule' />
                                          </li>
                                        </ul>
                                      )
                                    })
                                  ) : (
                                    <div />
                                  )}
                                </div>
                              ) : (
                                <form style={{ width: '75%', float: 'left', paddingLeft: '15px' }}>
                                  <FormGroup>
                                    <FormControl
                                      type='text'
                                      name='user'
                                      // value={this.props.typedText ? this.props.typedText : this.props.selectedUser.fullName}
                                      value={
                                        this.props.selectedUser &&
                                        (this.props.selectedUser.fullName || this.props.selectedUser.invitation)
                                          ? this.props.selectedUser.fullName || this.props.selectedUser.invitation
                                          : this.props.typedText
                                      }
                                      placeholder='Type email address or token and press invite'
                                      // onChange={this.onTypeSearch.bind(this, this.props.typedSearched)}
                                      onChange={this.handleChange.bind(this)}
                                    />
                                    <FormControl.Feedback />
                                  </FormGroup>
                                </form>
                              )}
                              {this.props.showSwitch === false ? (
                                <div style={{ paddingRight: '5px' }}>
                                  <Button
                                    style={{
                                      width: '20%',
                                      float: 'right'
                                    }}
                                    bsStyle='primary'
                                    onClick={this.addInvitee.bind(this)}>
                                    {' '}
                                    Invite{' '}
                                  </Button>
                                </div>
                              ) : (
                                <div />
                              )}
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                          </div>

                          {filteredUsers && filteredUsers.length && this.props.showSwitch === false ? (
                            <div>
                              {this.props.checkedByBuilding ? (
                                <div>
                                  {filteredUsers.map(user => {
                                    return (
                                      <Grid fluid={true}>
                                        <Row style={{ marginLeft: 0 }}>
                                          <Col>
                                            <div className='attendeeCircle avatar-image' style={{ margin: '8px' }}>
                                              <span>
                                                {user.image ? (
                                                  <Image
                                                    thumbnail
                                                    src={user.image}
                                                    onError={e => (e.target.src = '../images/guestAvatar.png')}
                                                    circle
                                                    className='avatar-image'
                                                  />
                                                ) : (
                                                  <Image
                                                    src='/images/guestAvatar.png'
                                                    circle
                                                    thumbnail
                                                    className='avatar-image'
                                                  />
                                                )}
                                              </span>
                                            </div>
                                          </Col>
                                          <Col>
                                            <h4 className='attendee-name'>
                                              <a href='#' onClick={this.onUserSelect.bind(this, user)}>
                                                {user.fullName || user.invitation}
                                              </a>
                                            </h4>
                                          </Col>
                                        </Row>
                                        <div className='horizontal-rule' />
                                      </Grid>
                                    )
                                  })}
                                </div>
                              ) : (
                                <div>
                                  {filteredUsers.map(user => {
                                    return (
                                      <Grid fluid={true}>
                                        <Row style={{ marginLeft: '10px' }}>
                                          <Col>
                                            <div className='attendeeCircle avatar-image' style={{ margin: '8px' }}>
                                              <span>
                                                {user.image ? (
                                                  <Image
                                                    thumbnail
                                                    src={user.image}
                                                    onError={e => (e.target.src = '../images/guestAvatar.png')}
                                                    circle
                                                    className='avatar-image'
                                                  />
                                                ) : (
                                                  <Image
                                                    src='/images/guestAvatar.png'
                                                    circle
                                                    thumbnail
                                                    className='avatar-image'
                                                  />
                                                )}
                                              </span>
                                            </div>
                                          </Col>
                                          <Col>
                                            <h4 className='attendee-name'>
                                              <a href='#' onClick={this.onUserSelect.bind(this, user)}>
                                                {user.fullName || user.invitation}
                                              </a>
                                            </h4>
                                          </Col>
                                        </Row>
                                        <div className='horizontal-rule' />
                                      </Grid>
                                    )
                                  })}
                                </div>
                              )}
                            </div>
                          ) : (
                            <div />
                          )}
                        </div>

                        <div>
                          {(inviteeEmail && (selectedBooking && this.props.account._id === selectedBooking.user._id)) ||
                          (this.props.account.role === 'company_manager' &&
                            found &&
                            this.props.account.role !== 'program_manager' &&
                            this.props.account.role !== 'building_manager') ? (
                            <div />
                          ) : (
                            <div style={{ width: '20%', float: 'right' }}>&nbsp;</div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div>
                        {selectedBooking ? (
                          <div>
                            {(this.props.account.role === 'company_manager' && found) ||
                            selectedBooking.user._id === this.props.account._id ? (
                              <div
                                style={{
                                  float: 'right',
                                  height: '2em',
                                  margin: '5px',
                                  paddingTop: '20px',
                                  paddingRight: '10px'
                                }}>
                                <Button
                                  // style={{ height: '100px' }}
                                  bsStyle='primary'
                                  // size='lg'
                                  onClick={this.showInvitationsList.bind(this)}>
                                  Add invitees
                                </Button>
                              </div>
                            ) : (
                              // <div
                              //   onClick={this.showInvitationsList.bind(this)}
                              //   className='inviteButton'
                              //   style={{
                              //     float: 'right',
                              //     height: '2em',
                              //     margin: '5px',
                              //     paddingTop: '15px',
                              //     paddingRight: '10px'
                              //   }}>
                              //   <h4>Add invitees</h4>
                              // </div>
                              <div />
                            )}

                            <br />
                            <br />
                            <br />
                            <br />
                            <Grid fluid={true}>
                              {selectedBooking.invitees.map(invitee => {
                                return (
                                  <Row style={{ margin: 0 }}>
                                    {(found && this.props.account.role === 'company_manager') ||
                                    (this.props.account.role !== 'tenant' && found) ||
                                    selectedBooking.user._id === this.props.account._id ||
                                    this.props.account.role === 'program_manager' ||
                                    this.props.account.role === 'building_manager' ? (
                                      <div>
                                        <Col>
                                          <div className='attendeeCircle avatar-image' style={{ margin: '8px' }}>
                                            <span>
                                              {invitee.user.image ? (
                                                <Image
                                                  thumbnail
                                                  src={invitee.user.image}
                                                  onError={e => (e.target.src = '../images/guestAvatar.png')}
                                                  circle
                                                  className='avatar-image'
                                                />
                                              ) : (
                                                <Image
                                                  src='/images/guestAvatar.png'
                                                  circle
                                                  thumbnail
                                                  className='avatar-image'
                                                />
                                              )}
                                            </span>
                                            {/* <span >
                                              {invitee.user.fullName
                                                .split(' ')
                                                .map(n => n[0])
                                                .join('')
                                                .toUpperCase()}
                                            </span> */}
                                          </div>
                                        </Col>
                                        <Col>
                                          <h4 className='attendee-name'>
                                            {invitee.user.fullName || invitee.user.invitation}
                                          </h4>
                                          {/* <div>
                                            <h4 style={{ marginTop: '23px' }}>{invitee.user.fullName}</h4>
                                          </div> */}
                                        </Col>
                                        <Col>
                                          {(this.props.account.role === 'company_manager' && found) ||
                                          selectedBooking.user._id === this.props.account._id ? (
                                            <div style={{ float: 'right', marginTop: '-35px' }}>
                                              <Button bsStyle='danger' onClick={this.removeInvitee.bind(this, invitee)}>
                                                Remove
                                              </Button>
                                            </div>
                                          ) : (
                                            <div />
                                          )}
                                        </Col>
                                      </div>
                                    ) : null}
                                  </Row>
                                )
                              })}
                            </Grid>
                          </div>
                        ) : (
                          <div />
                        )}
                        {selectedBooking.invitees.length ? (
                          <div />
                        ) : (
                          <div>
                            {(found && this.props.account.role === 'company_manager') ||
                            (this.props.account.role !== 'tenant' && found) ||
                            selectedBooking.user._id === this.props.account._id ||
                            this.props.account.role === 'program_manager' ||
                            this.props.account.role === 'building_manager' ? (
                              <div style={{ textAlign: 'center' }}>
                                <h4>No Attendees</h4>
                              </div>
                            ) : (
                              <div />
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div>
                  <div className='locationDetailsContainer'>
                    <div style={{ width: '100%', height: '350px' }}>
                      <Image
                        style={{
                          height: '100%',
                          width: '100%',
                          objectFit: 'cover',
                          objectPosition: '50% 50%'
                        }}
                        src={location.detailsImage}
                        responsive
                      />
                    </div>
                    <div className='content'>
                      <h4>{location.name}</h4>
                    </div>
                  </div>
                </div>
              )}
              {selectedBooking ? (
                <div />
              ) : (
                <div className='locationDescription locationDescriptionTop'>
                  <h4>{'Capacity: ' + location.capacity}</h4>
                  <h4>{location.description}</h4>
                </div>
              )}

              <div className='locationTimeslotInfo' style={{ paddingLeft: '10px', margin: '3px' }}>
                <div className='timeInfo'>
                  <SingleDatePicker
                    readOnly={true}
                    placeholder='Select Date'
                    openDirection='up'
                    date={filterDate}
                    onDateChange={this.handleDateChange.bind(this)}
                    focused={this.props.detailFocused}
                    onFocusChange={this.updateDateFocus.bind(this)}
                    id='details_filter_date'
                  />
                  <div
                    style={{
                      paddingLeft: '10px',
                      paddingRight: '10px',
                      margin: '3px',
                      width: '200px'
                    }}>
                    {selectedTimeslot ? (
                      <div>
                        {moment(selectedTimeslot.startDate).format('h:mm a') +
                          ' - ' +
                          moment(selectedTimeslot.endDate).format('h:mm a')}
                      </div>
                    ) : (
                      <div>&nbsp;</div>
                    )}
                  </div>
                </div>

                <div>
                  {selectedTimeslot && selectedBooking ? (
                    /* doar in cazul in care utilizatorul carea facut book pe timeslot nu sunt eu  */
                    <div>
                      {selectedBooking.user._id !== this.props.account._id ? (
                        /* in cazul in care eu sunt tenant voi vedea doar numele si compania utilizatorului care a facut book pe timeslot */
                        <div>
                          {this.props.account.role == 'tenant' ? (
                            <div className='text-center userInfo'>
                              <h4 onClick={this.selectTimeslot.bind(this, selectedTimeslot)}>
                                {selectedTimeslot.booking.user.fullName}
                                <span>({companyName})</span>
                              </h4>
                            </div>
                          ) : (
                            <div />
                          )}
                        </div>
                      ) : (
                        <div className='text-center unbookButton'>
                          <h4 onClick={this.unbookTimeslot.bind(this, selectedTimeslot, selectedBooking.user._id)}>
                            Unbook
                          </h4>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div />
                  )}

                  {selectedTimeslot && selectedTimeslot.booking ? (
                    /* doar in cazul in care utilizatorul carea facut book pe timeslot nu sunt eu  */
                    <div>
                      {selectedTimeslot.booking.user._id !== this.props.account._id ? (
                        /* in cazul in care eu sunt company_manager si voi avea cel putin o companie comuna cu utilizatorul voi avea celeasi drepturi ca si utilizatorul */
                        <div>
                          {this.props.account.role === 'company_manager' && found ? (
                            <div className='text-center unbookButton'>
                              <h4
                                onClick={this.unbookTimeslot.bind(
                                  this,
                                  selectedTimeslot,
                                  selectedTimeslot.booking.user._id
                                )}>
                                Unbook
                              </h4>
                            </div>
                          ) : (
                            <div>
                              {/* in cazul in care eu sunt company_manager si nu voi aveea nici o companie comuna cu utilizatorul
                               voi vedea doar numele si compania utilizatorului care a facut book pe timeslot */}
                              {this.props.account.role == 'company_manager' && !found ? (
                                <div className='text-center userInfo'>
                                  <h4 onClick={this.selectTimeslot.bind(this, selectedTimeslot)}>
                                    {selectedTimeslot.booking.user.fullName}
                                    <span>({companyName})</span>
                                  </h4>
                                </div>
                              ) : (
                                <div />
                              )}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div />
                      )}
                    </div>
                  ) : (
                    <div />
                  )}
                </div>

                {selectedBooking && selectedTimeslot.booking ? (
                  /* daca nu e acelais utilizator ca si mine */
                  <div>
                    {selectedTimeslot.booking.user._id !== this.props.account._id ? (
                      <div>
                        {this.props.account.role === 'program_manager' ||
                        this.props.account.role === 'building_manager' ? (
                          <div>
                            <div onClick={this.showInvitations.bind(this)}>
                              <div className='arrow-left' style={{ float: 'right' }} />
                            </div>
                          </div>
                        ) : (
                          <div />
                        )}
                      </div>
                    ) : (
                      <div />
                    )}
                  </div>
                ) : (
                  <div />
                )}

                {selectedBooking && selectedTimeslot.booking ? (
                  /* daca nu e acelais utilizator ca si mine */
                  <div>
                    {selectedTimeslot.booking.user._id !== this.props.account._id ? (
                      /* in cazul in care eu sunt company_manager si voi avea cel putin o companie comuna cu utilizatorul voi avea celeasi drepturi ca si utilizatorul */
                      <div>{this.props.account.role === 'company_manager' ? <div /> : <div />}</div>
                    ) : (
                      <div />
                    )}
                  </div>
                ) : (
                  <div />
                )}

                <div className='text-center inviteInfo'>{selectedTimeslot ? <h4 /> : <div />}</div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ height: '215px' }}>
            {availableIntervals.length == 0 ? (
              hideLocationDetails
            ) : (
              <div className='locationScrollableContent' style={{ height: '225px' }}>
                <Grid fluid={true}>
                  {organizedIntervals.map(row => (
                    <Row xs={12} sm={12} class='timeslotsInfo'>
                      {row.map(availableInterval => {
                        let linkButton = <div style={{ float: 'left', width: 'auto' }} />
                        let linkButtonDisabled = <div style={{ float: 'left', width: 'auto' }} />

                        let nextAvailableInterval = availableIntervals.find(interval => {
                          if (moment(interval.startDate).isSameOrAfter(moment(availableInterval.endDate))) {
                            return true
                          }
                          return false
                        })

                        if (nextAvailableInterval) {
                          if (location.bookings) {
                            let currentBooking = location.bookings.find(booking => {
                              if (
                                moment(booking.startDate).isSameOrBefore(moment(availableInterval.startDate)) &&
                                moment(booking.endDate).isSameOrAfter(availableInterval.endDate)
                              ) {
                                return true
                              }
                              return false
                            })

                            let nextBooking = location.bookings.find(booking => {
                              if (
                                moment(booking.startDate).isSameOrBefore(moment(nextAvailableInterval.startDate)) &&
                                moment(booking.endDate).isSameOrAfter(nextAvailableInterval.endDate)
                              ) {
                                return true
                              }
                              return false
                            })

                            if (currentBooking && nextBooking) {
                              if (currentBooking._id === nextBooking._id) {
                                linkButton = (
                                  <div
                                    onClick={this.unlinkBookings.bind(this, currentBooking, nextAvailableInterval)}
                                    style={{ width: 'auto' }}>
                                    <img
                                      style={{
                                        width: '1.5em',
                                        height: '1.5em',
                                        margin: '5px auto',
                                        display: 'block'
                                      }}
                                      src='/images/chain.png'
                                    />
                                  </div>
                                )
                                linkButtonDisabled = (
                                  <div style={{ width: 'auto' }}>
                                    <img
                                      style={{
                                        width: '1.5em',
                                        height: '1.5em',
                                        margin: '5px auto',
                                        display: 'block'
                                      }}
                                      src='/images/chain.png'
                                    />
                                  </div>
                                )
                              } else if (currentBooking.user._id === nextBooking.user._id) {
                                linkButton = (
                                  <div
                                    onClick={this.linkBookings.bind(this, currentBooking, nextBooking)}
                                    style={{ width: 'auto' }}>
                                    <img
                                      style={{
                                        width: '1.5em',
                                        height: '1.5em',
                                        margin: '5px auto',
                                        display: 'block'
                                      }}
                                      src='/images/unchain.png'
                                    />
                                  </div>
                                )
                                linkButtonDisabled = (
                                  <div style={{ width: 'auto' }}>
                                    <img
                                      style={{
                                        width: '1.5em',
                                        height: '1.5em',
                                        margin: '5px auto',
                                        display: 'block'
                                      }}
                                      src='/images/unchain.png'
                                    />
                                  </div>
                                )
                              }
                            }
                          }
                        }

                        if (availableInterval.booking) {
                          let selected = false
                          if (selectedTimeslot) {
                            selected = moment(selectedTimeslot.endDate).isSame(availableInterval.endDate)
                          }

                          if (
                            availableInterval.booking.user &&
                            availableInterval.booking.user._id == this.props.account._id
                          ) {
                            return (
                              <Col
                                class='text-center'
                                xs={3}
                                sm={3}
                                style={{
                                  marginTop: '5px',
                                  paddingRight: '0px',
                                  paddingLeft: '0px'
                                }}>
                                <Button
                                  style={{ float: 'left', width: '70%' }}
                                  class='btn-block btn-time'
                                  bsStyle={selected ? 'info btn-grey-dark btn-time' : 'primary btn-grey btn-time'}
                                  onClick={this.selectTimeslot.bind(this, availableInterval)}>
                                  {moment(availableInterval.startDate).format('h:mm a')}
                                </Button>
                                {linkButton}
                              </Col>
                            )
                          } else {
                            return (
                              <Col
                                class='text-center'
                                xs={3}
                                sm={3}
                                style={{
                                  marginTop: '5px',
                                  paddingRight: '0px',
                                  paddingLeft: '0px'
                                }}>
                                <Button
                                  style={{ float: 'left', width: '70%' }}
                                  class='btn-block btn-time'
                                  bsStyle='primary btn-info btn-time'
                                  onClick={this.selectTimeslot.bind(this, availableInterval)}>
                                  {moment(availableInterval.startDate).format('h:mm a')}
                                </Button>
                                {this.props.account.role === 'company_manager' && found ? (
                                  <div>{linkButton}</div>
                                ) : (
                                  <div>{linkButtonDisabled}</div>
                                )}
                              </Col>
                            )
                          }
                        } else {
                          return (
                            <Col
                              class='text-center'
                              xs={3}
                              sm={3}
                              style={{
                                marginTop: '5px',
                                paddingRight: '0px',
                                paddingLeft: '0px'
                              }}>
                              <Button
                                style={{ float: 'left', width: '70%' }}
                                bsStyle='default btn-time'
                                onClick={this.bookTimeslot.bind(this, availableInterval)}>
                                {moment(availableInterval.startDate).format('h:mm a')}
                              </Button>
                              <div>{linkButton}</div>
                            </Col>
                          )
                        }
                      })}
                    </Row>
                  ))}
                </Grid>
              </div>
            )}
          </Modal.Footer>
        </Modal>
        <BookingInvitation />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return { ...state.locationsReducer, account: state.authReducer.account }
}

export default withRouter(connect(mapStateToProps)(LocationDetails))

/* If I am a tenant:
	I should see the user name of the meeting organizer and company - DONE


If I am a Company Manager:
	and the meeting owner is in my company
		I should see the invitees list with invite status, I should have the same functionality as the meeting owner
		I should be able to unbook - DONE

	If the meeting owner is not in my company
		I should see the user name of the meeting organizer and company - DONE


If I am a Program Manager or Building Manager
	I should see the invitees list with invite status - DONE
	I should not be able to invitee or unbook, view only - DONE*/



// WEBPACK FOOTER //
// ./src/components/LocationDetails.js